import React from 'react'

const Banner = () => {
  return (
    <div className='banner'>
      Ready to see how <span style={{ color: "#fff", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "1.5rem" }}>.</span>  transforms your sourcing? <a href="/">Explore</a> Our Seamless Process.
    </div>
  )
}

export default Banner
